export const en = {
    cancel: 'Cancel',
    save: 'todo',
    title: 'todo'
};
